export const addNote = {
    method: 'POST',
    paths: [
        '/api/orgs/:orgId/locations/:locationId/orders/:orderId/transactions/:transactionId/note',
    ],
    fields: {
        text: {
            type: 'shortString',
            required: true,
        },
    },
};
//# sourceMappingURL=transactions_add_note.js.map